import { render, staticRenderFns } from "./CompraEmPalete.vue?vue&type=template&id=41ed9e91&scoped=true"
import script from "./CompraEmPalete.vue?vue&type=script&setup=true&lang=js"
export * from "./CompraEmPalete.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompraEmPalete.vue?vue&type=style&index=0&id=41ed9e91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ed9e91",
  null
  
)

export default component.exports